angular
    .module('app')
    .component('groups', {
        templateUrl: '/templates/pages/groups/groups.html',
        controller: 'GroupsController',
        controllerAs: 'vm',
    });